<template>
    <div class="transaction-main">
        <div class="main">
            <div class="filter-box">
                <!--<p class="fl  label">发票类型</p>-->
                <!--<select class="input-box fl select-text">-->
                    <!--<option value="">增值税专用发票</option>-->
                    <!--<option value="">增值税普通发票</option>-->
                <!--</select>-->
                <p class="pay-type fl label">申请时间</p>
                <el-date-picker class="fl "
                                v-model="startTime"
                                type="date"
                                size="small"
                                value-format="timestamp"
                                placeholder="选择日期">
                </el-date-picker>
                <p class="fl line-heiggt32">至</p>
                <el-date-picker class="fl"
                                v-model="endTime"
                                type="date"
                                size="small"
                                value-format="timestamp"
                                placeholder="选择日期">
                </el-date-picker>

                <button class="filter-button resetting fr" @click="reset">重置</button>
                <button class="filter-button search fr" @click="search">查询</button>
                <div class="clear"></div>
            </div>
            <div class="main-body">
                <el-table
                        :data="tableData"
                        :default-sort="{ prop: 'date', order: 'descending' }"
                        stripe
                        style="width: 97%"
                        class="body-table"
                        :row-style="{ height: '46px' }"
                        :header-cell-style="{ textAlign: 'center' }"
                        :cell-style="{ textAlign: 'center' }"
                >
                    <el-table-column prop="date" label="发票类型"></el-table-column>
                    <el-table-column prop="name" label="抬头类型"></el-table-column>
                    <el-table-column prop="address" label="申请人"></el-table-column>
                    <el-table-column prop="address" label="申请时间"></el-table-column>
                    <el-table-column prop="address" label="操作">
                        <a @click="showDetail" class="refund">查看</a>
                    </el-table-column>
                </el-table>
            </div>
            <div class="main-bottom">
                <el-pagination
                        background
                        layout="prev, pager, next"
                        :total="total"
                        class="fenye"
                        @current-change="current_change"
                >
                </el-pagination>
            </div>
        </div>
        <el-dialog
                title="待审核开票信息"
                :visible.sync="dialogVisible"
                width="600px"
                >
            <div class="text-box">
                <div class="line-text">
                    <div class="text fl">
                        <p class="fl label-text">发票类型</p>
                        <p class="fl content">增值税专用发票</p>
                    </div>
                    <div class="text fr">
                        <p class="fl label-text">发票抬头</p>
                        <p class="fl content">增值税专用发票</p>
                    </div>
                </div>
                <div class="line-text">
                    <div class="text fl">
                        <p class="fl label-text">单位税号</p>
                        <p class="fl content">12555986687222665</p>
                    </div>
                </div>
                <div class="clear"></div>
                <div class="more-line">
                    <span class="text">更多信息</span>
                </div>
                <div class="line-text">
                    <div class="text fl">
                        <p class="fl label-text">注册地址</p>
                        <p class="fl content">廊坊市广阳区经济技术开发区润泽道</p>
                    </div>
                    <div class="text fr">
                        <p class="fl label-text">注册电话</p>
                        <p class="fl content">12666599878</p>
                    </div>
                    <div class="clear"></div>
                </div>
                <div class="line-text">
                    <div class="text fl">
                        <p class="fl label-text">开户银行</p>
                        <p class="fl content">北京银行</p>
                    </div>
                    <div class="text fr">
                        <p class="fl label-text">银行账号</p>
                        <p class="fl content">758782734869324</p>
                    </div>
                    <div class="clear"></div>
                </div>
            </div>
            <div class="button-box" align="center">
                <button class="refuse">拒绝</button>
                <button class="pass">通过</button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
  import {getUnaudited} from '@/api/shop'
  export default {
    name: "transactionManage",
    data() {
      return {
        dialogVisible: false,
        date: '',
        tableData: [],
        total: 10,
        pageSize: 10, //每页的数据条数
        currentPage: 1, //默认开始页面
        istag: true,
        startTime: '',
        endTime: ''

      };
    },
    mounted(){
      this.getBillList()
    },
    methods: {
      current_change: function (currentPage) {
        this.currentPage = currentPage;
        this.getBillList()
      },

      search() {
        this.getBillList()
      },

      reset() {
        this.currentPage = 1;
        this.startTime = '';
        this.endTime = '';
        this.getBillList()
      },

      showDetail(){
        this.dialogVisible = true;
      },

      getBillList(){
        const postData = {
          length: this.pageSize,
          page: this.currentPage,
        }
        if(this.startTime){
          postData.startTime = this.startTime
        }
        if(this.endTime){
          postData.endTime = this.endTime
        }
        getUnaudited(postData).then(res => {
          this.tableData = res.data;
        })
      }
    }
  };
</script>

<style scoped lang="scss">
    @import "~@/css/order.scss";
    @import "~@/css/bill_dialogs.scss";
</style>
